import React, { FC } from 'react';

import style from './NoData.module.less';

export const NoData: FC<{ content?: string }> = ({ content }) => {
  return <div className={style.NoData}>{content || 'No data'}</div>
};
